<template>
  <div
    class="sttranmain"
    data-tst="ranges_main"
  >
    <RtLayout
      class="sttranmain_item z-index_4"
      :class="[
        { rtlay_1366: !rangesMaximized },
        { rtcs_5x: tabRange && (mobile || !rangesMaximized) },
        { rtcs_4x: tabRange && rangesMaximized },
        { 'rtcs_no-transition': mobile || rangesMaximized },
      ]"
      :hasCenter="hasCenter"
      :showLeft="true"
      :showCenter="tabRange && hasCenter"
      :showRight="tabRange"
    >
      <template #left>
        <RtTable
          :showProp="leftPlayerShowProp"
          :namespace="namespace"
          :canAISolve="canAISolve"
          :playerKey="playerLeftKey"
          :flipped="true"
          :playerDropdownOptions="playerDropdownOptions"
          :playersDetail="playersDetail"
          :l_tableSwitchAsMenu="l_tableSwitchAsMenu"
          tstPrefix="left_player"
          dataTst="range_table_left"
          rangeContentTstPrefix="left_range_content"
          :switcherStyle="`
                 min-width: 4rem;
                 --uns-opener-padding: 0.5rem;
                 --uns-opener-clr-back: var(--clr-black-2);
                 --uns-btn-padding: 0 0.75rem;
                 --uns-opener-padding: 0 1.25rem 0 0.5rem;
               `"
          :showRangeCopyBtn="true"
          :range="playerLeft?.range || []"
          :hasActions="playerLeft?.is_hero"
          :canBeLocked="playerLeft?.is_hero"
          :showBetsIn="showBetsIn"
          :tabRange="tabRange"
          :solution="l_sol_dynamic.solution"
          :bettingInfo="bettingInfo"
          :showFlopContent="showFlopContent"
          :hasShortcutBtn="hasShortcutBtn"
          :tableGroups="tableGroups"
          :viewProps="viewProps"
          :filterCombos="filterCombos"
          :filterEvCompare="filterEvCompare"
          :evProps="evProps"
          :grouping="grouping"
          :useHex="useHex"
          :tableMouseover="tableMouseover"
          :street="street"
          :rangesMaximized="rangesMaximized"
          :max1280="max1280"
          :asEmpty="viewProps.hero_emptyTable || skeletonOnly"
          :noValue="viewProps.hero_noValueTable"
          :valueProp="viewProps.hero_valuePropTable"
          @select-player="handleSelectPlayer($event, 'L')"
          @select-range-content="handleRangeContentSelect($event, 'L')"
          @combo-click="handleComboClick"
        />
      </template>
      <template #center>
        <div
          class="sttranmain_center"
          :class="{
            sttranmain_center_maximized: rangesMaximized,
          }"
        >
          <div
            class="sttranmain_center_inner scroll-bottom-overlay"
            style="--clr-scrl-back: var(--clr-back); --scrl-height: 1.25rem"
          >
            <div
              v-if="rangesMaximized || hasCenterControls"
              class="gw-box f-column"
              style="margin: var(--center-top-margin)"
            >
              <div
                class="d-flex"
                style="gap: 0.25rem"
              >
                <UnSwitcherNew
                  :hasText="true"
                  :asMenu="false"
                  swKey="sw_study_range_center"
                  class="flex-1"
                  style="--gwbtn-flex: 1"
                />
                <slot name="center_top"></slot>
                <div
                  v-if="hasRangeControls"
                  class="gw_box f-center"
                  style="gap: 2px; padding: 0 0.375rem; --clr-box-back: var(--clr-black-2)"
                >
                  <StudyEvConverterSwitcher :hasICMConverter="!!bettingInfo.evIcmConverters[0]" />
                  <StudyRangeHeightSwitcher />
                  <StudyGroupingSwitcherNew />
                </div>
              </div>
            </div>

            <div class="sttranmain_center_inner_scrollable no-scroll-track">
              <StudyRangesCenter
                v-bind="l_ccProps"
                :namespace="namespace"
                :canAISolve="canAISolve"
                :playerLeftKey="playerLeftKey"
                :playerRightKey="playerRightKey"
                :catDraws="catDraws"
                :catEqBuckets="catEqBuckets"
                :catEqBucketsAdvanced="catEqBucketsAdvanced"
                :catHands="catHands"
                :combos="combos"
                :filterActions="filterCombos.actions"
                :filterCategories="filterCategories"
                :filterCombos="filterCombos"
                :filteredHeroHandsIds="filteredHeroHandsIds"
                :filteredOpponentHandsIds="filteredOpponentHandsIds"
                :gameformat="gameformat"
                :grouping="grouping"
                :hSpot="hSpot"
                :handInfo="handInfo"
                :hasEqBuckets="true"
                :hasEqBucketsAdvanced="true"
                :hasFilterPills="hasFilterPills"
                :hasShortcutBtn="hasShortcutBtn"
                :hero="hero"
                :heroHandsIds="tableMouseover || heroGroupId ? heroHandsIds : []"
                :heroLeft="heroLeft"
                :opponent="opponent"
                :playerLeft="playerLeft"
                :playerRight="playerRight"
                :players="players"
                :learningMode="learningMode"
                :mobile="mobile"
                :opponentHandsIds="tableMouseover || opponentGroupId ? opponentHandsIds : []"
                :player="viewProps.player"
                :rangeKey="viewProps.rangeKey"
                :rangeTab="rangeTab"
                :showBetsIn="showBetsIn"
                :showFlopContent="showFlopContent"
                :skeletonOnly="skeletonOnly"
                :solution_picked="solution_picked"
                :street="street"
                :useHex="useHex"
                style="--tracactr-last-item-padding: 0 0 1rem 0"
                @eqchart:click="handleEqChartClick"
              />
            </div>
          </div>
        </div>
      </template>
      <template #right>
        <RtTable
          :showProp="rightPlayerShowProp"
          :namespace="namespace"
          :canAISolve="canAISolve"
          :playerKey="playerRightKey"
          :hasPlayerDropdownOptions="hasPlayerDropdownOptions"
          :hasRangeContentSwitcher="hasPlayerDropdownOptions"
          :playerDropdownOptions="playerDropdownOptions"
          :playersDetail="playersDetail"
          :l_tableSwitchAsMenu="l_tableSwitchAsMenu"
          tstPrefix="right_player"
          rangeContentTstPrefix="right_range_content"
          :switcherStyle="`
                min-width: 4rem;
                --uns-opener-padding: 0.5rem;
                --uns-opener-clr-back: var(--clr-black-2);
                --uns-btn-padding: 0 0.75rem;
                --uns-opener-padding: 0 1.25rem 0 0.5rem;
              `"
          :showRangeCopyBtn="true"
          :range="playerRight?.range || []"
          :hasActions="playerRight?.is_hero"
          :canBeLocked="playerRight?.is_hero"
          :showBetsIn="showBetsIn"
          :tabRange="tabRange"
          :solution="l_sol_dynamic.solution"
          :bettingInfo="bettingInfo"
          :showFlopContent="showFlopContent"
          :hasShortcutBtn="hasShortcutBtn"
          dataTst="range_table_right"
          :tableGroups="tableGroups"
          :viewProps="viewProps"
          :filterCombos="filterCombos"
          :filterEvCompare="filterEvCompare"
          :evProps="evProps"
          :grouping="grouping"
          :useHex="useHex"
          :tableMouseover="tableMouseover"
          :street="street"
          :rangesMaximized="rangesMaximized"
          :max1280="max1280"
          :asEmpty="viewProps.hero_emptyTable || skeletonOnly"
          :noValue="viewProps.hero_noValueTable"
          :valueProp="viewProps.hero_valuePropTable"
          @select-player="handleSelectPlayer($event, 'R')"
          @select-range-content="handleRangeContentSelect($event, 'R')"
          @combo-click="handleComboClick"
        />
      </template>
    </RtLayout>
    <div
      v-if="hasBottom"
      v-show="tabRange && !rangesMaximized"
      class="sttranmain_item sttranmain_item_bottom z-index_1"
      style="overflow: hidden"
    >
      <EquityChartComplex2
        v-if="players"
        :hands="showFlopContent ? combos : []"
        class="std_cont"
        :rangeKey="viewProps.rangeKey"
        style="padding: 0.5rem 0.25rem 0.25rem 0.25rem"
        styleLegend="
                 --legend-size: 0.8rem;
                 --legend-circle-size: 10px;
                 --legend-inset: 1rem auto auto 1.5rem;
                "
        styleSvg="
                --stroke-width: 3;
                --clr-svg-back: rgba(255, 255, 255, 0.025);
                "
        :skeleton="!showFlopContent || !playerLeftKey"
        :players="players"
        :activeHands="activeHandsForPlayers"
        :filteredPlayersHandsIds="filteredPlayersHandsIds"
        :player="viewProps.player"
        :hasTitle="true"
        :hasControls="true"
        :hasGuide="true"
        :simpleView="false"
        :tstPrefix="''"
        @combos:mouseenter="handleEqChartMouseEnter"
      >
        <MessageOverlaySkeleton
          v-if="!showFlopContent"
          class="gw_mesblock_container"
          :isBlurred="true"
          :isTopDown="true"
          style="
            --content-margin: auto auto auto auto;
            --radius: 6px;
            left: -0.25rem;
            top: -0.35rem;
            height: calc(100% + 0.45rem);
            width: calc(100% + 0.25rem);
            --back-from: var(--clr-black-0);
            --back-to: var(--clr-black-0);
          "
        >
          <MessagesGoPostflop
            :namespace="namespace"
            :canAISolve="canAISolve"
            :title="$t('messages.select_postflop_spot')"
          />
        </MessageOverlaySkeleton>
      </EquityChartComplex2>
    </div>

    <GwMenu
      v-if="rangesMaximized"
      ref="gwmenu"
      :referenceEl="referenceEl"
      :isMovable="true"
      :boundary="boundary"
      :placement="mobile ? 'bottom' : 'top'"
      @close="resetPlayersGroups()"
    >
      <template #default="{ methods }">
        <StudyCombos
          class="gw_floating-hands large-scroll-track"
          :style="boundary ? `max-width: ${boundary.offsetWidth}px` : ''"
          :street="street"
          :player="$store.getters.sol_detail_player"
          :group="playerDetail?.group"
          :customHandsIds="playerDetail?.hands_ids"
          :viewProps="viewProps"
          :filterCombos="filterCombos"
          :filterEvCompare="filterEvCompare"
          :evProps="evProps"
          :mobile="mobile"
          :showFlopContent="showFlopContent"
          :grouping="grouping"
          :showBetsIn="showBetsIn"
          :bettingInfo
          :rangeKey="viewProps.rangeKey"
          :showProp="tabRange ? playerDetail?.range_content : playerDetail?.strategy_content"
          :asEmpty="viewProps.player_emptyHands"
          :useHex="useHex"
          :hasPremiumGameformat="hasPremiumGameformat"
          :gameformat="gameformat"
          :rangeTab="rangeTab"
          @click:blocker="methods.toggleOpen(false)"
        />
      </template>
    </GwMenu>
  </div>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import MessageOverlaySkeleton from '@/components/Poker/Overlays/MessageOverlaySkeleton'
import StudyRangeHeightSwitcher from '@/components/Switchers/StudyRangeHeightSwitcher'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import StudyEvConverterSwitcher from '@/components/Switchers/StudyEvConverterSwitcher'
import { toggleArrByKey } from '@/helpers/helpers'
import RtLayout from '@/components/RangeTables/RtLayout'
import StudyRangesCenter from '@/components/Study/StudyRangesCenter'
import StudyGroupingSwitcherNew from '@/components/Switchers/StudyGroupingSwitcherNew'
import StudyCombos from '@/components/Study/StudyCombos'
import MessagesGoPostflop from '@/components/Poker/Overlays/Messages/MessagesGoPostflop'
import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'
import RtTable from '@/components/Study/RtTable'
import EquityChartComplex2 from '../Charts/LineCharts/EquityChartComplex2.vue'

export default {
  name: 'StudyRangesMain2',
  components: {
    GwMenu,
    RtTable,
    MessageOverlaySkeleton,
    MessagesGoPostflop,
    EquityChartComplex2,
    StudyGroupingSwitcherNew,
    RtLayout,
    StudyCombos,
    StudyRangesCenter,
    StudyRangeHeightSwitcher,
    UnSwitcherNew,
    StudyEvConverterSwitcher,
  },
  mixins: [float_mix, format_mix],
  props: {
    namespace: { required: true, type: String },
    canAISolve: { required: true, type: Boolean },
    hasBottom: { type: Boolean, default: true },
    hasCenter: { type: Boolean, default: true },
    hasTableTile: Boolean,
    rangeTab: String,
    hSpot: Object,

    hasCenterControls: Boolean,

    hasFilterPills: Boolean,
    hasRangeControls: Boolean,
    hasICMConverter: Boolean,

    hasShortcutBtn: { type: Boolean, default: true },

    tableSwitchAsMenu: { default: undefined },

    // solData: { default: () => { } },
    solution: { default: () => [] },
    solution_picked: { default: () => [] },
    // eqBuckets: { default: () => { } },
    tableGroups: { default: () => [] },
    combos: { default: () => [] },

    showBetsIn: String,
    bettingInfo: Object,
    street: String,
    heroGroupId: String,
    opponentGroupId: String,
    heroGroupsIds: Array,
    opponentGroupsIds: Array,
    heroLeft: Boolean,
    hero: Object,
    opponent: Object,
    players: { default: () => [] },
    rangesMaximized: Boolean,
    showFlopContent: Boolean,
    mobile: Boolean,
    max1280: Boolean,

    heroGroup: Object,
    opponentGroup: Object,

    learningMode: Boolean,
    skeletonOnly: Boolean,

    catDraws: Array,
    catHands: Array,
    catEqBuckets: Array,
    catEqBucketsAdvanced: Array,

    heroHandsIds: { default: () => [] },
    opponentHandsIds: { default: () => [] },

    filteredHeroHandsIds: { default: () => [] },
    filteredPlayersHandsIds: { default: () => [] },
    filteredOpponentHandsIds: { default: () => [] },

    viewProps: Object,
    filterCombos: Object,
    filterEvCompare: Object,
    filterCategories: { default: () => [] },
    evProps: Object,
    grouping: String,
    useHex: Boolean,
    tableMouseover: Boolean,
    playersDetail: { default: () => [] },
    hasPremiumGameformat: Boolean,
    gameformat: Object,
    handInfo: Object,
    ccProps: { default: () => {} },
  },
  data() {
    return {
      referenceEl: null,
      boundary: null,
      playerLeftKey: '0', // default hero
      playerRightKey: '1', // default opponent
    }
  },
  created() {
    window.addEventListener('focus', this.handleWindowFocus, false)
  },
  beforeUnmount() {
    window.removeEventListener('focus', this.handleWindowFocus, false)
  },
  methods: {
    handleRangeContentSelect(selectedContent, side) {
      const playerKey = side === 'L' ? this.playerLeftKey : this.playerRightKey
      this.$store.commit('sol_detail_set', {
        player: playerKey,
        key: 'players_detail',
        playerProperty: 'range_content',
        value: selectedContent.payload,
      })
    },
    handleSelectPlayer(selectedPlayer, side) {
      this.resetPlayersGroups()
      const currentSide = side === 'L' ? 'Left' : 'Right'
      const otherSide = side === 'L' ? 'Right' : 'Left'
      if (selectedPlayer.payload === this[`player${otherSide}Key`]) {
        this[`player${otherSide}Key`] = this[`player${currentSide}Key`]
      }
      this[`player${currentSide}Key`] = selectedPlayer.payload

      this.$store.commit('sol_detail_set', { key: 'study_player', value: selectedPlayer.payload })

      if (
        !this.playersDetail[selectedPlayer.payload].group ||
        !this.playersDetail[selectedPlayer.payload].hands_ids
      ) {
        const group = this.tableGroups.find(g => g.players?.[selectedPlayer.payload]?.range > 0)
        if (group) {
          this.$store.commit('sol_detail_set', {
            key: 'players_detail',
            playerProperty: 'group',
            value: group,
            player: selectedPlayer.payload,
          })
          this.$store.commit('sol_detail_set', {
            key: 'players_detail',
            playerProperty: 'hands_ids',
            value: null,
          })
          this.$store.commit('sol_detail_set', {
            player: selectedPlayer.payload,
            key: 'players_detail',
            playerProperty: 'hands_ids',
            value: group.combos.map(c => c.id),
          })
        }
      }
    },
    handleEqChartMouseEnter(hands) {
      this.$store.dispatch('sol_detail_hover_chart', {
        hands,
        tableGroups: this.tableGroups,
      })
    },
    handleWindowFocus() {
      // Reset sol detail to prevent highlighting from getting stuck when switching tabs
      this.$store.commit('sol_detail_set', {
        key: 'players_detail',
        playerProperty: 'groups_ids',
        value: null,
      })
    },
    resetPlayersGroups() {
      this.$store.commit('sol_detail_set', {
        key: 'players_detail',
        playerProperty: 'group_id',
        value: '',
      })
    },
    closeFloatingCombos() {
      if (this.$refs.gwmenu) {
        this.$refs.gwmenu.toggleOpen(false)
      }
    },
    handleComboClick({ event, combos, showProp, player }) {
      if (!this.rangesMaximized) return
      if (this.referenceEl?.id === `${player}_${combos.id}`) {
        this.referenceEl = null
        this.boundary = null
        this.resetPlayersGroups()
        return
      }

      if (player && combos) {
        if (this.$refs.gwmenu) {
          const virtualEl = document.getElementById(`${player}_${combos.id}`)

          const table = this.$refs[`table_${player}`]
          this.boundary = this.mobile ? null : table?.$el
          this.referenceEl = virtualEl
          this.$refs.gwmenu.toggleOpen(true)
        }
      } else {
        this.referenceEl = null
        this.boundary = null
      }
    },
    setCenterTab(key) {
      this.$store.dispatch('switchers_set_item', {
        key: 'sw_study_range_center',
        item: { payload: key },
      })
    },
    handleActionClick(action) {
      let res = this.filterCombos.actions
      res = toggleArrByKey({
        arr: res,
        items: action.actions,
        item: action,
        key: 'code',
      })
      this.$store.dispatch('sol_filters_apply', { key: 'actions', value: res })
    },
    handleEqChartClick() {
      this.$store.dispatch('router_set_dialogs', `chart-eq-dialog`)
    },
  },
  computed: {
    leftPlayerShowProp() {
      let value = this.tabRange
        ? this.playersDetail[this.playerLeftKey]?.range_content
        : this.playersDetail[this.playerLeftKey]?.strategy_content

      const showPropTableDict = { overview_range: 'range', overview_all: 'strategy' }
      value = showPropTableDict[value] || value
      return value
    },
    rightPlayerShowProp() {
      return this.playersDetail[this.playerRightKey]?.range_content
    },
    playerLeft() {
      return this.players[this.playerLeftKey] || {}
    },
    playerRight() {
      return this.players[this.playerRightKey] || {}
    },
    playerDropdownOptions() {
      return this.players
        .filter(player => player.position)
        .map((player, playerIndex) => ({
          payload: playerIndex.toString(),
          text: player.position,
          icon: player.is_hero ? 'mdi-crown' : undefined,
        }))
    },
    hasPlayerDropdownOptions() {
      return this.players?.filter(player => player.position).length > 1
    },
    activeHandsForPlayers() {
      return this.playersDetail.map(player => player?.hands_ids || [])
    },
    playerDetail() {
      return this.playersDetail[this.viewProps.player]
    },
    l_ccProps() {
      const stratab = this.$store.getters.sw_study_range_center === 'strategy'
      const rangetab = this.$store.getters.sw_study_range_center === 'range'
      const max = this.rangesMaximized
      const straMax = stratab && max
      const rangeMax = rangetab && max
      const res = {
        hasBreakdownInHorizontalChart: this.showFlopContent && straMax,
        hasHorizontalChartItem: straMax,
        hasHorizontalChart: straMax,
        hasRangeCategoriesItem: straMax && this.showFlopContent,
        hasRangeCategories: straMax && this.showFlopContent,
        hasRangeCategoriesHands: true,
        hasRangeCategoriesDraws: true,
        hasRangesComparisonItem: !max ? true : rangetab,
        hasRangesComparison: !max ? true : rangetab,
        hasEqChartItem: rangeMax && this.showFlopContent,
        hasEqChart: rangeMax && this.showFlopContent,
        hasFilterSuitsItem: rangeMax,

        ...this.ccProps,
      }
      return res
    },
    tabRange() {
      return this.rangeTab === 'range'
    },
    tabCenterStrategy() {
      return this.$store.getters.sw_study_range_center === 'strategy'
    },
    l_tableSwitchAsMenu() {
      return this.tableSwitchAsMenu ?? (this.max1280 ? true : !this.rangesMaximized)
    },
    l_sol_dynamic() {
      const res = {
        solution: this.$store.getters.sol_data_solution(),
      }
      return this.$store.getters.sol_data_updated && this.$store.getters.sol_filter_active
        ? res
        : res
    },
  },
  watch: {
    tabRange: {
      handler() {
        if (this.playerDropdownOptions?.length) {
          this.handleSelectPlayer(this.playerDropdownOptions[0], 'L')
        }
      },
      immediate: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.sttranmain {
  --gap: var(--laytsttd-gap, 0.5rem);
  --padding-content: var(--laytsttd-padding-content, 0.5rem);
  --clr-back: var(--clr-black-1);
  --stramain-gap: 0rem;

  --center-top-margin: 1.75rem 0.5rem 1rem 0.5rem;

  flex-direction: column;
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
  &_item {
    padding: var(--padding-content);
    background: var(--clr-back);
    border-radius: 6px;
    position: relative;
    gap: var(--stramain-gap);
    &_bottom {
      margin-top: var(--gap);
      display: flex;
      flex: 1;
    }
  }
  &_ranges-comparison {
    padding: 0.5rem 0 0 0;
  }
  &_center {
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
    gap: var(--gap);
    --center-width: 16rem;
    --inner-max-height: calc(100% - var(--gap));
    --center-padding-top: 0.5rem;
    padding-top: var(--center-padding-top);
    min-width: calc(var(--center-width) + var(--gap));
    &_maximized {
      --center-padding-top: 0rem;
      --padding-content: 0 0.5rem;
      --center-width: clamp(16rem, 22rem, 19.5vw);
      --inner-max-height: 100%;
    }
    &:hover {
      &:not(.sttranmain_center_maximized) {
        --inner-max-height: calc(var(--vh-100) - 18rem - var(--gap));
        z-index: 2;
      }
    }
    &_controls {
      display: flex;
      width: 100%;
      position: sticky;
      padding: 1.875rem 0 0 0;
      top: 0;
      z-index: 6;
      background: var(--clr-back);
    }
    &_inner {
      width: 100%;
      overflow: hidden;
      min-height: 0;
      display: flex;
      flex-direction: column;
      max-height: var(--inner-max-height);

      position: absolute;
      border-radius: 6px;
      background: var(--clr-back);
      transition: 0.22s;
      border-radius: 6px;
      &_scrollable {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        width: 100%;
        padding: var(--padding-content);
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }
}

@media (max-width: 1023px) and (orientation: portrait) {
  .sttranmain_center {
    --center-top-margin: 0.5rem 0 0.5rem 0;
    --padding-content: 0.5rem 0 0 0;
  }
}
</style>
